module.exports = __webpack_public_path__ + "static/img/subway-05.33bf3e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/subway-05.png
// module id = 150
// module chunks = 0